import React from 'react'
import styled from 'styled-components'
import { PATHPREFIX } from '../../../constants'

type VideoComponentProps = { className?: string; width: number; height: number; src: string }
let absolutePattern = /^https?:\/\//i;

const VideoComponent = (props: VideoComponentProps) => {
  const videoPath = absolutePattern.test(props.src) ? props.src : PATHPREFIX + props.src
  return <video autoPlay loop playsInline muted {...props} src={videoPath} />
}

const Video = styled(VideoComponent)`
  display: block;
  width: 100%;
  height: auto;
  margin: 1.5rem 0;
`

export default Video
